import type { IconNode } from '../types';

/**
 * @name layer-arrow-down
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTB2MTAiIC8+CiAgPHBhdGggZD0iTTIyIDEwYTEgMSAwIDAxLS41OS45MmwtNS4wNzcgMi4zMDgiIC8+CiAgPHBhdGggZD0iTTIyLjAxNyAxMC4wMDVhMSAxIDAgMDAtLjU5Ny0uOTE2bC04LjU5LTMuOTFhMiAyIDAgMDAtMS42Ni4wMDFMMi42IDkuMDhhMSAxIDAgMDAtLjAyIDEuODMxbDUuMDkzIDIuMzE2IiAvPgogIDxwYXRoIGQ9Im05IDE3IDMgMyAzLTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/layer-arrow-down
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LayerArrowDown: IconNode = [
  ['path', { d: 'M12 10v10' }],
  ['path', { d: 'M22 10a1 1 0 01-.59.92l-5.077 2.308' }],
  [
    'path',
    {
      d: 'M22.017 10.005a1 1 0 00-.597-.916l-8.59-3.91a2 2 0 00-1.66.001L2.6 9.08a1 1 0 00-.02 1.831l5.093 2.316',
    },
  ],
  ['path', { d: 'm9 17 3 3 3-3' }],
];

export default LayerArrowDown;
